/**
 * RomCard — v1.1 refactor.
 * Range-of-Motion (active & passive) table with reference normal values
 * per joint·motion (Norkin & White 5th ed. / AAOS). Region-aware filter.
 * Lifted out of ObjectiveAssessment.jsx.
 */
import React from 'react';
import { Move, Trash2 } from 'lucide-react';

const SIDES = ['L','R','Both','N/A'];

export default function RomCard({
  rows = [], regionFilter = 'all', romTests = [], patient_id,
  updRow, addRow, delRow, appendScribeRow,
  Section, GridTable, AddBtn,
}) {
  return (
    <Section title="Range of motion — Active & Passive" icon={Move} testid="sec-rom"
             scribeKey="rom" patientId={patient_id}
             onScribeText={appendScribeRow('rom', (text) => ({
               joint: 'AI', plane: '', active: '', passive: '', side: 'L',
               endfeel: '', notes: text, reference: '',
             }))}>
      <p className="text-xs text-fg-muted mb-3">
        Pick a joint·motion — reference normal AROM is shown automatically.
      </p>
      <GridTable cols={['Joint · Motion','Side','AROM (°)','PROM (°)','Reference normal']}>
        {(rows || []).map((r, i) => {
          const opt = romTests.find((t) => t.joint === r.joint && t.motion === r.motion);
          const filtered = romTests.filter((t) => regionFilter === 'all' || t.region === regionFilter);
          return (regionFilter === 'all' || (opt && opt.region === regionFilter) || !opt) && (
            <tr key={i} data-testid={`gon-${i}`}>
              <td>
                <select className="input" value={opt ? opt.label : ''}
                        onChange={(e) => {
                          const sel = romTests.find((t) => t.label === e.target.value);
                          updRow('goniometer', i, sel
                            ? { joint: sel.joint, motion: sel.motion, region: sel.region }
                            : { joint: '', motion: '' });
                        }}>
                  <option value="">—</option>
                  {filtered.map((t) => <option key={t.label} value={t.label}>{t.label}</option>)}
                </select>
              </td>
              <td>
                <select className="input" value={r.side || ''}
                        onChange={(e) => updRow('goniometer', i, { side: e.target.value })}>
                  {['', ...SIDES].map((s) => <option key={s}>{s}</option>)}
                </select>
              </td>
              <td>
                <input className="input" value={r.aROM || ''}
                       onChange={(e) => updRow('goniometer', i, { aROM: e.target.value })}/>
              </td>
              <td>
                <input className="input" value={r.pROM || ''}
                       onChange={(e) => updRow('goniometer', i, { pROM: e.target.value })}/>
              </td>
              <td className="text-xs text-fg-muted font-mono">{opt?.normal || '—'}</td>
              <td className="print:hidden">
                <button onClick={() => delRow('goniometer', i)} className="text-[#B83A3A] p-1">
                  <Trash2 className="w-4 h-4"/>
                </button>
              </td>
            </tr>
          );
        })}
      </GridTable>
      <AddBtn onClick={() => addRow('goniometer', {
        joint: '', motion: '', side: '', aROM: '', pROM: '',
      })} testid="add-gon"/>
    </Section>
  );
}
